import axios from "axios";
import { SERVER_URL } from "Constants";
import { accountType } from "Models/Enums";
import { AxiosConfigFactory } from "Util/AxiosUtil";
import { PaginationParams, SortingParams, EntityControllerData, SearchParams } from "./shared";

export type BusinessPaymentMethod = {
	businessId: string;
	businessName: string;
	paymentMethodId: string | null;
	organisationId: string;
	organisationAccountType: accountType;
	organisationEnforcePayment: boolean;
}

export type BusinessEntityDto = {
	id: string;

	abn: string;
	isActive: boolean;
	name: string;

	abnEntityName?: string;
	abnEntityTypeDescription?: string;

	email?: string;

	phone?: string;

	enabledForMonitor: boolean;
	enabledForApprove: boolean;
	enabledForPPSR: boolean;

	organisationId: string;
}

export const BusinessPaymentMethodUtil = {
	getConsumptionChargeType(model: BusinessPaymentMethod): accountType {
		if (model.organisationAccountType === 'PAYG') return 'PAYG';
		if (model.organisationAccountType === 'INVOICED' && model.organisationEnforcePayment) return 'PAYG';
		return 'INVOICED';
	}
}
/**
 * @returns List of business entities viewable by the user and the payment method if exists on the business
 * refer to apiStripe.tsx -> getBusinessPaymentMethod(...) for fetching payment method for a specific business.
 */
export async function getBusinessPaymentMethods(
	filterByOrgId?: string,
	filterForEnabledMonitor?: boolean,
	filterForEnabledApprove?: boolean) {

	const url = `${SERVER_URL}/api/entity/BusinessEntity/payments`;
	return await axios.get<BusinessPaymentMethod[]>(url, {
		params: {
			filterByOrgId: filterByOrgId,
			filterForEnabledMonitor: filterForEnabledMonitor,
			filterForEnabledApprove: filterForEnabledApprove
		}
	});
}

// Developer note: Pagination and sorting not applied yet
export type BusinessEntityQueryOptions = PaginationParams & SortingParams & SearchParams & {
	filterByOrgId?: string;
}

export async function fetchBusinessEntityList(queryParams?: BusinessEntityQueryOptions) {
	const url = `${SERVER_URL}/api/entity/BusinessEntity`;
	const requestConfig = AxiosConfigFactory.createRequestConfig(queryParams);
	return await axios.get<EntityControllerData<BusinessEntityDto>>(url, requestConfig);
}

